import {  useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { QualidadeItemProcessosRiscosInteresseForm, QualidadeItemProcessosRiscosInteresseSchema } from "../../../schemas/CadastroProcessosRiscosItem/qualidade_processos_item_interesse";
import { ItemProcessoRiscosInteresseLista } from "../../../../domain/models/processos_riscos_item_interesse_lista";
import { useCallback, useEffect } from "react";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";
import PrimaryButton from "../../../../../../common/components/primary_button";

 
type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedItemProcessosInteresse: ItemProcessoRiscosInteresseLista | null;
  onClose: () => void;
  onSubmit: (e: QualidadeItemProcessosRiscosInteresseForm) => void;
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void;
};

export const InteresseModal = ({
  open, saving,loading,selectedItemProcessosInteresse,
  onClose, onSubmit,onOpenChangeHistory
}: Props) => {

  const hookForm = useForm<QualidadeItemProcessosRiscosInteresseForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(QualidadeItemProcessosRiscosInteresseSchema),
    defaultValues: {
      Descricao: '',
      Expectativa: '',
      Acompanhamento: '',
      ResultadosAlcancados: '',
      IdItemProcessoInteresse: undefined,
      IdItemProcesso: undefined
    }
  });

  useEffect(() => {
    if (open) {
      if (selectedItemProcessosInteresse) {
        hookForm.reset({
          Descricao: selectedItemProcessosInteresse.Descricao,
          Expectativa: selectedItemProcessosInteresse.Expectativa,
          Acompanhamento: selectedItemProcessosInteresse.Acompanhamento,
          IdItemProcessoInteresse: selectedItemProcessosInteresse.IdItemProcessoInteresse,
          IdItemProcesso: selectedItemProcessosInteresse.IdItemProcesso,
          ResultadosAlcancados: selectedItemProcessosInteresse.ResultadosAlcancados
        });
      } else {
        hookForm.reset({
          Descricao: '',
          Expectativa: '',
          Acompanhamento: '',
          ResultadosAlcancados: '',
          IdItemProcessoInteresse: undefined,
          IdItemProcesso: undefined,
        });
      }
    }
  }, [hookForm, open, selectedItemProcessosInteresse]);

  const handleSubmit = useCallback((form: QualidadeItemProcessosRiscosInteresseForm) => {
    if (!saving){
      onSubmit(form);
      hookForm.reset(); 
    } 
  }, [hookForm, onSubmit, saving]);
  
  const handleClose = useCallback(() => {
    if (!saving){
      onClose();
      hookForm.reset(); 
    } 
  }, [hookForm, onClose, saving]);
  const handleChangeHistory = useCallback(() => {
      if (selectedItemProcessosInteresse) {
        onOpenChangeHistory(selectedItemProcessosInteresse.IdItemProcessoInteresse, LogTipoTabela.ITEM_PROCESSO_INTERESSE);
      }
    }, [selectedItemProcessosInteresse, onOpenChangeHistory]);


  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      PaperProps={{
        component: 'form',
        onSubmit: hookForm.handleSubmit(handleSubmit)
      }}
      sx={{ "& .MuiDialog-paper": { maxWidth: "800px", width: "100%" } }}
    >
      <DialogTitle>
        Cadastrar/Editar
      </DialogTitle>

      <DialogContent>
        <FormContainer title={"Cadastrar/Editar"} arrangement="fullRow">
          <div className="flex flex-col w-full gap-4 pt-2">
            
            <DefaultFormInput
              name="Descricao"
              label="Descricao"
              reactHookForm={hookForm}
              required={true}
            />
            
            <DefaultFormInput
              name="Expectativa"
              label="Expectativa"
              multiline={true}
              rows={4}
              reactHookForm={hookForm}
            />
            
            <DefaultFormInput
              name="Acompanhamento"
              label="Forma de Monitoramento."
              multiline={true}
              rows={4}
              reactHookForm={hookForm}
            />
            
            <DefaultFormInput
              name="ResultadosAlcancados"
              label="Resultados Alcançados."
              multiline={true}
              rows={4}
              reactHookForm={hookForm}
            />
            
          </div>
        </FormContainer>
      </DialogContent>

      <DialogActions>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {
                isNotNullOrUndefined(selectedItemProcessosInteresse) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={handleChangeHistory}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>
  
            <div className="flex flex-row gap-2">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={handleClose}>
                  Cancelar
                </h1>
              </div>
  
              <div className="w-[120px]">
                {saving ? (
                  <PrimaryButton
                    buttonColor="primary-green">
                    Salvando...
                  </PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    buttonColor="primary-green">
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </DialogActions>
    </Dialog>
  );
}